import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import Transactions from 'us.collection.transactions';
import { CaseType } from 'us.helper/types/enums';
import { INavigationData } from 'us.collection/interfaces';

interface ICnt_Transactions {
    caseNo: number;
    caseType: CaseType
}

const Cnt_Transactions: React.FC<ICnt_Transactions> = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state as INavigationData;

    const onMinimize = (url: string) => {
        navigate(url, { state });
    }

    return (
        <Transactions.Components.TransactionsHome onMinimize={() => onMinimize(`/case/${props.caseNo}`)}  {...props} />
    )
}

export default Cnt_Transactions;